import React from "react";

import MarsbetLoading from "@pages/casino/assets/icons/MarsbetLoading.jsx";
import BetnimbusLoading from "@pages/casino/assets/images/betnimbus_loading.gif";
import DefaultLoading from "@pages/casino/assets/images/loading.gif";
import OddsfusionLoading from "@pages/casino/assets/images/oddsfusion_loading.gif";
import ZigybetLoading from "@pages/casino/assets/images/zigybet-loading.png";

import {
	ExpandedLoadingContainer,
	GenericLoadingContainer,
	LoadingContainer,
	LoadingRing,
	LogoWrapper,
	MainLogo,
	PreloaderBg,
} from "./elements";

export const GannarLoader = () => (
	<ExpandedLoadingContainer>
		<div style={{ width: "130px", height: "135px" }}>
			<img src="/loading_up.png" />
		</div>
	</ExpandedLoadingContainer>
);

export const CoinebetLoader = () => (
	<ExpandedLoadingContainer>
		<div style={{ width: "100%", height: "100%" }}>
			<img src="/loading_up.png" />
		</div>
	</ExpandedLoadingContainer>
);

export const ZigybetLoader = () => {
	return (
		<PreloaderBg>
			<LogoWrapper>
				<MainLogo
					src={ZigybetLoading}
					alt="Zigybet Logo"
				/>
				<LoadingRing />
			</LogoWrapper>
		</PreloaderBg>
	);
};

export const OddsfusionLoader = () => {
	return (
		<ExpandedLoadingContainer>
			<div style={{ width: "150px", height: "150px" }}>
				<img
					src={OddsfusionLoading}
					alt="Loading"
					width={150}
					height={150}
				/>
			</div>
		</ExpandedLoadingContainer>
	);
};

export const DefaultLoader = () => {
	return (
		<LoadingContainer>
			<img
				src={DefaultLoading}
				alt="Loading"
				width={250}
				height={250}
			/>
		</LoadingContainer>
	);
};

export const GenericLoader = () => {
	return (
		<GenericLoadingContainer
			className="loading-img"
			src="/generic_loading.gif"
			alt="Loading"
		/>
	);
};

export const MarsLoader = (props) => {
	return (
		<LoadingContainer>
			<MarsbetLoading {...props} />
		</LoadingContainer>
	);
};

export const BetnimbusLoader = () => {
	return (
		<ExpandedLoadingContainer>
			<div style={{ width: "250px", height: "150px" }}>
				<img
					src={BetnimbusLoading}
					alt="Loading"
					width={250}
					height={150}
				/>
			</div>
		</ExpandedLoadingContainer>
	);
};

const Loader = () => {
	if (window.ENABLE_MARS_LOADING) {
		return <MarsLoader />;
	}

	if (
		window.HAS_GANNAR_LOADING ||
		window.TENANT === "novero" ||
		window.TENANT === "luckykingbet" ||
		window.TENANT === "chainspin" ||
		window.TENANT === "rollblock" ||
		window.TENANT === "flashsportscasino"
	) {
		return <GannarLoader />;
	}

	if (window.TENANT === "coinebet") {
		return <CoinebetLoader />;
	}

	if (window.TENANT === "oddsfusion") {
		return <OddsfusionLoader />;
	}

	if (window.TENANT === "betnimbus") {
		return <BetnimbusLoader />;
	}

	return (
		<img
			src="/loading_up.png"
			style={{ width: "130px", height: "135px" }}
		/>
	);
};

export default Loader;
